@if (pageItem) {
  <div [id]="getId" [ngClass]="nodeClass(pageItem)" class="row">
    <div class="col">
      <span class="fa-solid fa-grip-vertical mr-2 text-muted"></span>
      <div class="edit-menu-item-icon">
        <span [class]="iconClass"></span>
      </div>
      <span [innerText]="pageItem.name || ''" style="white-space: pre;"></span>
    </div>
    <div class="col-auto">
      <div class="edit-menu-item-functions">
        <div class="d-inline-flex" ngbDropdown>
          @if (displayActionMenu) {
            <button class="btn btn-xs btn-outline-primary dropdown-no-arrow" id="dropdownBasic1"
              ngbDropdownToggle>
              <span class="fa-solid fa-ellipsis-vertical"></span>
            </button>
          }
          <div aria-labelledby="dropdownBasic1" ngbDropdownMenu>
            @if (displayDeleteAndEditButton) {
              <button (click)="editPage()"
                [disabled]="isAlteringDisabled || (!isPageOwner && !isSuperAdmin)"
                ngbDropdownItem>
                <span class="fa-solid fa-pen"></span>
                <span [innerHtml]="'Edit ' + itemTypeCategory|translate"></span>
              </button>
            }
            @if (displayShareButton) {
              <button (click)="share()" [disabled]="isAlteringDisabled" ngbDropdownItem>
                <span class="fa-solid fa-eye"></span>
                <span [innerHtml]="'Share page'|translate"></span>
              </button>
            }
            @if (displayUnshareButton) {
              <button (click)="unshare()"
                [disabled]="isAlteringDisabled || (!isPageOwner && !isSuperAdmin)" ngbDropdownItem>
                <span class="fa-solid fa-eye"></span>
                <span [innerHtml]="'Unshare page'|translate"></span>
              </button>
            }
            @if (displayDeleteAndEditButton) {
              <button #deleteButton (click)="onDelete(pageItem)"
                [disabled]="isAlteringDisabled || (!isPageOwner && !isSuperAdmin)"
                [ngClass]="{'text-danger': !deleteButton.classList.contains('disabled')}"
                ngbDropdownItem>
                <span class="fa-solid fa-trash"></span>
                <span [innerHtml]="'Delete ' + itemTypeCategory|translate"></span>
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
@if (editPageName && formIsActive) {
  <scitis-edit-page-inline-form (newPageCancel)="onCancelSavePage()" (newPageSave)="onSavePage($event)"
    (propertiesFallback)="setPropertiesFallback($event)"
    [allPagesInsideNode]="allPagesInsideNode" [baseMenuItems]="baseMenuItems"
    [pageItem]="pageItem"
    [pageItemsToBeDeleted]="pageItemsToBeDeleted"
    [pageTypeOptions]="pageTypeOptions"
    [userMenuItems]="userMenuItems">
  </scitis-edit-page-inline-form>
}

@if (editNode && formIsActive) {
  <scitis-edit-node-inline-form (newNodeCancel)="onCancelSaveNode()"
    (newNodeSave)="onSaveNode($event)"
    (propertiesFallback)="setPropertiesFallback($event)"
    [nodeItem]="pageItem" [userMenuItems]="userMenuItems">
  </scitis-edit-node-inline-form>
}

@if (isNode) {
  <div [(dragulaModel)]="updatedNodeUserMenuItems" [dragula]="dragAndDropUserMenuItems"
    [ngClass]="secondLevelContainerClass">
    @for (nodeUserMenuItem of updatedNodeUserMenuItems; track nodeUserMenuItem) {
      <scitis-second-level-page-item (deletePageItemInsideNode)="onDeletePageInsideNode(nodeUserMenuItem)"
        (disableSaveButton)="onDisableSaveButton($event)"
        (pageFormIsActive)="onDeactivatePageForms($event)"
        (savePageItemInsideNode)="onSavePageInsideNode(nodeUserMenuItem)"
        (sharePageItemInsideNode)="onSharePageInsideNode(nodeUserMenuItem)"
        [allPagesInsideNode]="allPagesInsideNode" [baseMenuItems]="baseMenuItems"
        [isAdminOrHigher]="isAdminOrHigher"
        [isHigherThanAdmin]="isHigherThanAdmin"
        [ngClass]="nodeClass(nodeUserMenuItem)"
        [nodeUserMenuItem]="nodeUserMenuItem"
        [pageTypeOptions]="pageTypeOptions" [userMenuItems]="userMenuItems"
        class="list-group-children page-inside-node">
      </scitis-second-level-page-item>
    }
    @if (displayDummyContainerForEmptyNode) {
      <div [ngClass]="doNotDropHereClass" class="alert alert-dropzone mb-0 mt-2">
        <span [innerHtml]="'Drop items here.' | translate" class="text-muted"></span>
      </div>
    }
  </div>
}
